
export const getExamen = async (rutAlumnos = '') => {

    const url = `/api/exams/${rutAlumnos}`;
    const resp = await fetch(url);
    const result = await resp.json();

    // console.log(result);

    return { result };
}